import { ReconciliationNonConsecutiveStatementsBalancesError } from "@common/contracts/reconciliation.contract";
import { currencyFormatter } from "@common/helpers/currency";
import { ErrorToast } from "@design-system/ToastMessages/ErrorToast";

interface Props {
    error: ReconciliationNonConsecutiveStatementsBalancesError;
}

export const ReconciliationNonConsecutiveStatementsBalancesErrorToast: React.FC<
    Props
> = ({ error }) => (
    <ErrorToast>
        <div>
            Uploaded statements balances are not consecutive.{" "}
            {currencyFormatter.format(error.previousStatementClosingBalance)}{" "}
            closing balance (<strong>{error.previousStatementFileName}</strong>)
            → {currencyFormatter.format(error.currentStatementOpeningBalance)}{" "}
            opening balance (<strong>{error.currentStatementFileName}</strong>).
        </div>
    </ErrorToast>
);
